<template>
  <b-card>
    <b-row>
      <b-col>
        <Form
          :handle-submit="onSendForm"
          :values="item"
          :violations="violations"/>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import Form from './AgreementUploadForm'

export default {
  name: 'AgreementFileUploadCreate',
  components: {
    Form
  },
  data () {
    return {
      item: {
        title: '',
        description: ''
      }
    }
  },
  watch: {
    created (val) {
      if (val) this.$router.push({ name: 'EXSBBankList' })
    }
  },
  computed: {
  },
  methods: {
    onSendForm () {
      this.create(this.item)
    }
  }
}
</script>

<style scoped>

</style>
